import * as React from "react";
import { cn } from "@/lib/cn";

/**
 * One number, with the word that says what it counts.
 *
 * The caption is `--muted-foreground`, which is 5.62:1 rather than a decorative
 * grey -- it is the only thing saying what the number means.
 */
export function Kpi({
  label,
  value,
  hint,
  tone,
  className,
}: {
  label: string;
  value: React.ReactNode;
  hint?: string;
  /** Only for counts that MEAN something is waiting for a person. */
  tone?: "attention";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-lg border bg-card p-4 shadow-card",
        tone === "attention" ? "border-warning/40" : "border-border",
        className,
      )}
    >
      <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className="mt-1.5 text-2xl font-semibold tracking-tight nums">{value}</div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
